import React, { useEffect, useMemo, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../store/hook';
import { useParams } from 'react-router-dom';
import {
  getOrderMasterComplete,
  selectCheckedTermsList,
  selectOrderMasterInfo,
} from '../../../../store/features/purchaseSlice';
import { PaymentMethod } from '../../../../enum';
import CreditCard from './creditcard';
import Deposit from './deposit';
import BankTransfer from './banktransfer';
import Point from './Point';
import ChannelService from '../../../../api/ChannelService';
import { postTermAgreements } from '../../../../api/utils/api/termApi';

const CompleteBranch = () => {
  const orderMasterId = useParams().orderMasterId;

  const dispatch = useAppDispatch();
  const orderMasterInfo = useAppSelector(selectOrderMasterInfo);
  useEffect(() => {
    dispatch(
      getOrderMasterComplete({
        url: '/v1/order/master',
        orderMasterId: orderMasterId,
      }),
    );
    ChannelService.hideChannelButton();

    return () => {
      ChannelService.showChannelButton;
    };
  }, []);

  // 결제 페이지에서 동의한 약관 목록
  const checkedTermsList = useAppSelector(selectCheckedTermsList);

  // 동의한 약관 기록 요청데이터
  const agreementsPayload = useMemo(() => {
    const orderItems = orderMasterInfo?.template?.order_items ?? [];

    if (
      !orderMasterId ||
      orderItems.length === 0 ||
      checkedTermsList.length === 0
    ) {
      return null;
    }

    const orderedProductIds = new Set(
      orderItems.map((item: any) => String(item.product_id)),
    );

    const agreements = checkedTermsList.flatMap((term) =>
      (term.productBundles ?? [])
        .filter((bundle) => orderedProductIds.has(String(bundle.productId)))
        .map((bundle) => ({
          termsId: String(term.id),
          productId: String(bundle.productId),
          orderId: String(orderMasterId),
        })),
    );

    return agreements.length > 0 ? { agreements } : null;
  }, [orderMasterId, orderMasterInfo, checkedTermsList]);

  // 재호출 방지용
  const savingRef = useRef(false);

  useEffect(() => {
    if (!orderMasterId) return;
    if (!agreementsPayload) return;

    const savedKey = `order-agreement-saved:${orderMasterId}`;

    // 이미 저장 완료된 주문이면 재호출 방지
    if (sessionStorage.getItem(savedKey) === 'true') return;

    // 현재 저장 요청이 진행 중이면 재호출 방지
    if (savingRef.current) return;

    savingRef.current = true;

    const saveAgreements = async () => {
      try {
        await postTermAgreements(agreementsPayload);
        sessionStorage.setItem(savedKey, 'true');
      } catch (error) {
        savingRef.current = false;
        console.error('약관 동의 기록 저장 실패', error);
      }
    };

    void saveAgreements();
  }, [agreementsPayload]);

  return (
    <>
      {/*
      [차후] 케이스 구분 처리 필요
      1. 예외 오류 케이스인 경우
    */}
      {orderMasterInfo &&
        orderMasterInfo.payment_method === PaymentMethod.CREDIT_CARD && (
          <CreditCard data={orderMasterInfo} orderMasterId={orderMasterId} />
        )}
      {orderMasterInfo &&
        orderMasterInfo.payment_method === PaymentMethod.DEPOSIT && (
          <Deposit data={orderMasterInfo} orderMasterId={orderMasterId} />
        )}
      {orderMasterInfo &&
        orderMasterInfo.payment_method === PaymentMethod.BANK_TRANSFER && (
          <BankTransfer data={orderMasterInfo} orderMasterId={orderMasterId} />
        )}
      {orderMasterInfo &&
        orderMasterInfo.payment_method === PaymentMethod.POINT && (
          <Point data={orderMasterInfo} orderMasterId={orderMasterId} />
        )}
    </>
  );
};

export default CompleteBranch;
